import axios from 'axios';
import constants from '@/assets/js/constants.js';

const state = {
    userStructures: []
};

const getters = {
    allUserStructures: state => state.userStructures
};

const actions = { 
    async fetchUserStructures({ commit }, callbackFunction)
    {
        axios.post(constants.baseApiUrl + 'StructureUser/GetCurrentUserStructures', null)
            .then(res => 
            {
                commit('setUserStrucutures', res.data);

                if (callbackFunction != null)
                {
                    callbackFunction();
                }
            })
            .catch(err => console.log('from delegations.js, error is ' + err));
    },
};

const mutations = {
    setUserStrucutures: (state, userStructures) => (state.userStructures = userStructures)
};

export default {
    state,
    getters,
    actions,
    mutations
};